import { EntityTypeEnum } from '../enums/entity-type.enum';
import { RoleEnum } from '../enums/role.enum';

export const getRolesIds = (roles: RoleEnum[]): number[] =>
    roles.map((role: RoleEnum): number => {
        if (role.toLowerCase() === RoleEnum.ADMINISTRATOR) {
            return 1;
        }
        if (role.toLowerCase() === RoleEnum.ALDERMAN) {
            return 2;
        }
        if (role.toLowerCase() === RoleEnum.DIRECTOR) {
            return 3;
        }
        if (role.toLowerCase() === RoleEnum.ASSISTANT) {
            return 4;
        }
        if (role.toLowerCase() === RoleEnum.SECRETARY) {
            return 5;
        }
        if (role.toLowerCase() === RoleEnum.TEACHER) {
            return 6;
        }
        if (role.toLowerCase() === RoleEnum.SUPERVISOR) {
            return 7;
        }
        if (role.toLowerCase() === RoleEnum.PARENT) {
            return 8;
        }

        return 0;
    });

export const getRoleById = (rolesIds: number[]): RoleEnum[] =>
    rolesIds?.map(
        (id: number): RoleEnum => {
            if (id === 1) {
                return RoleEnum.ADMINISTRATOR;
            }
            if (id === 2) {
                return RoleEnum.ALDERMAN;
            }
            if (id === 3) {
                return RoleEnum.DIRECTOR;
            }
            if (id === 4) {
                return RoleEnum.ASSISTANT;
            }
            if (id === 5) {
                return RoleEnum.SECRETARY;
            }
            if (id === 6) {
                return RoleEnum.SUPERVISOR;
            }
            if (id === 7) {
                return RoleEnum.TEACHER;
            }
            if (id === 8) {
                return RoleEnum.PARENT;
            }
            return RoleEnum.ADMINISTRATOR;
        }
    );

export const getEntityType = (entity: string): EntityTypeEnum => {
    if (entity.toLowerCase() === EntityTypeEnum.ADMINISTRATOR) return EntityTypeEnum.ADMINISTRATOR;
    if (entity.toLowerCase() === EntityTypeEnum.CLASS) return EntityTypeEnum.CLASS;
    if (entity.toLowerCase() === EntityTypeEnum.EMPLOYEE) return EntityTypeEnum.EMPLOYEE;
    if (entity.toLowerCase() === EntityTypeEnum.GROUP) return EntityTypeEnum.GROUP;
    if (entity.toLowerCase() === EntityTypeEnum.PARENT) return EntityTypeEnum.PARENT;
    if (entity.toLowerCase() === EntityTypeEnum.RELATIVE) return EntityTypeEnum.RELATIVE;
    if (entity.toLowerCase() === EntityTypeEnum.SCHOOL) return EntityTypeEnum.SCHOOL;
    else return EntityTypeEnum.STUDENT;
};
